var DestinationsService = /** @class */ (function () {
    function DestinationsService(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Find
     * @param iataCode
     * @returns any Successful response
     * @throws ApiError
     */
    DestinationsService.prototype.getApiV1DestinationsAirportsFind = function (iataCode) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/destinations/airports/find',
            query: {
                'iataCode': iataCode,
            },
        });
    };
    /**
     * All Destinations
     * A successful response would return a response like:
   *
   * ``` json
   * {
     * "status": 200,
     * "code": "",
     * "message": "Success",
     * "data": [
       * {
         * "locCode": "AAE",
         * "locName": "Annaba Les Salines",
         * "locCountry": "DZA",
         * "locCity": "Annaba",
         * "locDomestic": false
         * }
         * ]
         * }
         *
         * ```
     * @returns any Successful response
     * @throws ApiError
     */
    DestinationsService.prototype.getApiV1DestinationsAllDestinations = function () {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/destinations/AllDestinations',
        });
    };
    return DestinationsService;
}());
export { DestinationsService };
